import { weekAhead } from "@toema/shared-types";
import type { HoursProfile, OpeningWindow } from "@toema/shared-types";

const DAY_LABELS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;

export interface FooterRow {
  readonly date: string;
  readonly day: number;
  readonly name: string;
  readonly note: string | null;
  readonly windows: readonly OpeningWindow[];
  readonly isToday: boolean;
}

export function footerRows(profile: HoursProfile, at: Date): readonly FooterRow[] {
  return weekAhead(profile, at)
    .map((entry, offset) => ({
      date: entry.date,
      day: entry.day,
      name: DAY_LABELS[entry.day] ?? "",
      note: entry.isException ? entry.label : null,
      windows: entry.windows,
      isToday: offset === 0,
    }))
    .sort((a, b) => a.day - b.day);
}

export function describeWindows(windows: readonly OpeningWindow[]): string {
  if (windows.length === 0) return "Closed";
  return windows.map((w) => `${w.from} – ${w.to}`).join(", ");
}
